import * as React from 'react';
import logo from '../assets/images/vine-centre-logo.png';
import { NavLink } from 'react-router-dom';
import Button from '@mui/material/Button';

const mainLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: "Who's Who", path: '/whoswho' },
  { label: 'Programmes', path: '/programmes' },
  { label: 'Famous Faces', path: '/famous' },
  { label: 'Room Hire', path: '/roomhire' },
];

export default function SideNav() {
  return (
    <nav className="side-nav">
      <div className="side-nav-logo">
        <img src={logo} alt="Vine Centre Logo" style={{ height: 90, margin: '2rem auto 1.5rem auto', display: 'block', background: '#fff', borderRadius: 16, padding: 14, boxShadow: '0 4px 24px rgba(0,0,0,0.13)', border: '2px solid #BFC0C2' }} />
      </div>
      <div className="side-nav-links">
        {mainLinks.map(link => (
          <NavLink key={link.label} to={link.path} className={({ isActive }) => isActive ? 'active' : ''}>
            {link.label}
          </NavLink>
        ))}
        <Button
          variant="contained"
          component={NavLink}
          to="/contact"
          sx={{
            mt: 3,
            px: 4,
            py: 1.3,
            fontWeight: 800,
            fontSize: '1.13rem',
            borderRadius: 3,
            background: 'var(--vine-accent)',
            color: 'var(--vine-dark)',
            boxShadow: '0 2px 12px rgba(123,30,58,0.10)',
            textTransform: 'none',
            width: '100%',
            '&:hover': {
              background: 'var(--vine-main)',
              color: 'var(--vine-secondary)',
            },
          }}
        >
          Contact Us
        </Button>
      </div>
    </nav>
  );
}